import { useMemo } from "react";

import { useSelector } from "react-redux";

import {
  FieldConfiguration,
  getSideLoadedFieldConfigurationsForUser,
} from "components/Business/SideLoadedBusinesses/CompareModal/fieldConfigurations";

import {
  LIVESTOCK_AGENT_CONTENT_TYPE_NAME,
  SALEYARD_ADMIN_CONTENT_TYPE_NAME,
} from "constants/users";

import { getIsLivestockAgent, getIsSaleyardAdmin } from "selectors";

export function useUserRoleContentTypeName(): string | null {
  const isSaleyardAdmin = useSelector(getIsSaleyardAdmin);
  const isLivestockAgent = useSelector(getIsLivestockAgent);
  if (isSaleyardAdmin) {
    return SALEYARD_ADMIN_CONTENT_TYPE_NAME;
  }
  if (isLivestockAgent) {
    return LIVESTOCK_AGENT_CONTENT_TYPE_NAME;
  }
  return null;
}

export function useSideLoadedFieldConfigurations(): {
  userRoleContentTypeName: string | null;
  configurations: FieldConfiguration[];
} {
  const userRoleContentTypeName = useUserRoleContentTypeName();
  const configurations = useMemo(
    () => getSideLoadedFieldConfigurationsForUser(userRoleContentTypeName),
    [userRoleContentTypeName],
  );
  return { userRoleContentTypeName, configurations };
}
